import _ from 'lodash'
import { connect } from 'react-redux'
import { createSelectorCreator } from 'reselect'
import { currentSubStationSelector } from './withCurrentSubStation'
import { numeralFormat } from '../../../../../lib/renderUtil'
import { formValueSelector } from '../../../Common/forms'
import { getGpm } from '@vzmi/shp_shared_compo/helpers/proposalHelpers'
import { showOnlyNumber } from '../../../../lib/formatter'
import { isNumberOrNumberString } from '../../../../lib/Validator'
import { numberNormalizer } from '../ProposalForm/Shared/normalizers'
import { PROPOSAL_LISTING_FORM_KEY } from '../../../../constants/proposalTypes'

const selector = formValueSelector(PROPOSAL_LISTING_FORM_KEY)
const getGpmData = state => selector(state, 'product.cost', 'listing.price')

const hashFn = (...args) => args.reduce(
  (acc, val) => acc + '-' + JSON.stringify(val),
  ''
)
const customSelectorCreator = createSelectorCreator(_.memoize, hashFn)

const getUnderSubStationGpm = (listingGpm = null, subStationGpm = null) => {
  return !_.isNull(listingGpm) && !_.isNull(subStationGpm)
    ? showOnlyNumber(listingGpm) < showOnlyNumber(subStationGpm)
    : false
}

const gpmFormatter = originalGpm => {
  if (_.isNull(originalGpm)) { return '--' }
  const gpmToPercentage = numeralFormat(
    originalGpm,
    {
      format: '0.00',
      allowZero: true
    })

  return `${gpmToPercentage}%`
}

const getListingGpm = (price = '', cost = '') => {
  const normalizedAmount = [price, cost].map(value => isNumberOrNumberString(value)
    ? value
    : numberNormalizer(value)
  )
  return getGpm(...normalizedAmount)
}

const getComputedGpm = customSelectorCreator([currentSubStationSelector, getGpmData], (currentSubStation, gpmData) => {
  const cost = _.get(gpmData, 'product.cost', '')
  const price = _.get(gpmData, 'listing.price', '')
  const listingGpm = getListingGpm(price, cost) * 100
  const subStationGpm = showOnlyNumber(_.get(currentSubStation, 'gpm', 0)) * 100
  return {
    listingGpm: gpmFormatter(listingGpm),
    subStationGpm: gpmFormatter(subStationGpm),
    underSubStationGpm: getUnderSubStationGpm(listingGpm, subStationGpm)
  }
})

export default function withListingGpm (MainComponent) {
  return connect(state => ({ ...getComputedGpm(state) }))(MainComponent)
}
